import {LinearGradient} from 'expo-linear-gradient';
import React, {Component, useRef} from 'react';
import {Dimensions, Image, Text, TouchableOpacity, View} from 'react-native';
import close from '../../assets/closeicon.png';
import i18n from 'i18n-js';
import { MaterialIcons } from '@expo/vector-icons';
// import Close from "../../closeicon.png";
// let linkShare = window.open("google.com")
export default class internateConnectionAlert extends Component {
  constructor(props) {
    super(props);
    this.state = {
      windowWidth: Dimensions.get('window').width,
      hideModalAlert: true
    };
  }
  updateDimensions = () => {
    this.setState({
      windowWidth: window.innerWidth
    });
  };
  componentDidMount() {
    window.addEventListener('resize', this.updateDimensions);
  }
  // hideModal = () => {
  //   this.setState({hideModalAlert : false})
  // }
  componentWillUnmount() {
    window.removeEventListener('resize', this.updateDimensions);
  }
  openUrl = () => {
    let url = 'https://www.speedtest.net/';
    window.open(url);
  };
  render() {
    return (
      <>
        <View>
          <LinearGradient
            colors={['#a73737', '#e74c3c', '#7a2828']}
            style={{
              justifyContent :'center',
              position: 'fixed',
              flexDirection: 'row',
              // height: 40,
              display: 'flex',
              alignItems: 'center',
              // justifyContent: "center",
              top: 120,
              left: 0,
              right: 0,
              marginLeft: 'auto',
              marginRight: 'auto',
              padding: 4,
              marginTop: 20,
              shadowOffset: {width: 0, height: 0},
              shadowRadius: 3.84,
              shadowColor: '#000',
              shadowOpacity: 0.9,
              zIndex: 9,
              // width:this.state.windowWidth >= 600 ? "60%" : "90%"
              width: this.state.windowWidth >= 600 ? '30%' : '90%',
              borderRadius: 5,
              zIndex: 9
            }}
          >
            <Text
              style={{
                marginRight: 5,
                fontWeight: 'bold',
                fontSize: 16,
                color: '#fff'
              }}
            >
              {this.props?.message ? this.props?.message : i18n.t(`session.connectionCheck`)}     
              {!this.props?.message && <MaterialIcons name="signal-wifi-off" style={{position :'absolute', top :'0'}}size={24} color="rgb(255, 255, 255)" />}
            </Text>

            </LinearGradient>
        </View>
      </>
    );
  }
}
